const Toast = ({ message, type }) => {
  const colors = {
    error: 'bg-check',
    warning: 'bg-accentOrange',
    success: 'bg-accentGreen',
    info: 'bg-[#4A9EFF]'
  };

  const icons = {
    error: '⚠️',
    warning: '⚡',
    success: '✓',
    info: 'ℹ️'
  };

  return (
    <div className={`
      fixed top-20 left-1/2 transform -translate-x-1/2
      px-6 py-3 rounded-lg shadow-2xl z-50
      flex items-center gap-3
      ${colors[type] || colors.info}
      animate-slideDown
    `}>
      <span className="text-2xl">{icons[type] || icons.info}</span>
      <span className="text-white font-medium">{message}</span>
    </div>
  );
};

export default Toast;
